import { render, staticRenderFns } from "./Dash-posts-feed-sort-panel.vue?vue&type=template&id=8735c3f0"
import script from "./Dash-posts-feed-sort-panel.vue?vue&type=script&lang=js"
export * from "./Dash-posts-feed-sort-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports